module.exports = __webpack_public_path__ + "bh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bh.svg
// module id = 448
// module chunks = 0